import { Component, OnInit } from '@angular/core';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { LoginService } from '../../../login/login.service';
import { firstValueFrom } from 'rxjs';
import { ExtensionsService } from '../../_services/extensions.service';
import { Extension } from '../../_types/extension';
import { User } from 'src/app/modules/users/_types/user';
import { UsersService } from 'src/app/modules/users/_services/users.service';
import { LocalStorageService } from 'angular-web-storage';
import { environment } from 'src/environment/environment';
import { DDIsService } from 'src/app/modules/users/_services/ddis.service';
import { DDI } from 'src/app/modules/users/_types/ddi';

@Component({
    selector: 'app-extensions-detail',
    templateUrl: './extensions-detail.component.html',
    styleUrls: ['./extensions-detail.component.css'],
    standalone: false
})
export class ExtensionsDetailComponent implements OnInit {

  public extension: Extension = new Extension();  
  public user: User = new User();  
  public ddi: DDI = new DDI();  
  public pbxserver: string = '-';
  public pbxport: string = '5060';
  public microsipDirectoryUrl: string = '';

  constructor(
    private extensionsService: ExtensionsService,
    private config: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private userService: UsersService,
    private ddisService: DDIsService
  ) { 
    this.pbxserver = environment.pbx.server;
    this.pbxport = environment.pbx.port.toString();
    this.microsipDirectoryUrl = environment.api_gw + 'communications/phone/microsip/contacts';
  }

  ngOnInit() {
    let id = this.config.data.id;
    if(id){
      this.loadData(id);
    }
  }


  async loadData(id: string) {
    this.extension = await firstValueFrom(this.extensionsService.get(id));
    this.loadUser(this.extension.userId);
  }

  async loadUser(id:string) {
    this.user = await firstValueFrom(this.userService.get(id));
    var parts = this.user.sipTransport.split('-');
    this.pbxport = parts[parts.length - 1];
    if(isNaN(this.pbxport as any)){
      this.pbxport = environment.pbx.port.toString();
    }
    if(this.user.outboundDDIId) this.laodDDI(this.user.outboundDDIId);

  }

  async laodDDI(id:string) {
    this.ddi = await firstValueFrom(this.ddisService.get(id));
  }

  cancel() {
    this.dynamicDialogRef.close();
  }

}
